import {createSelector, createSlice} from '@reduxjs/toolkit';
import {SUB_ROLE} from "../types.ts";

const name = "SUB_ROLE";

interface INITIAL_STATE {
    subRole: SUB_ROLE | null;
}

const initialState: INITIAL_STATE = {
    subRole: null
}

const subRoleSlice = createSlice({
    name,
    initialState,
    reducers: {
        updateSubRoleDetails: (state, { payload }: {payload: SUB_ROLE}) => {
            state.subRole = payload;
        },
    }
});

export const roleSelectors = {
    getSubRoleDetails: createSelector(
        (state) => {
            return state.roles.subRole;
        },
        (subRole) => subRole,
    ),
}

const { reducer, actions } = subRoleSlice;
export const { updateSubRoleDetails } = actions;
export default reducer;